module.exports = __webpack_public_path__ + "img/collection-memoireRingsConfigurator.86b1fef.webp";